import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { MaterialModule } from 'src/app/material.module';
import { CererePriorityModule } from 'src/app/platform/nomenclatoare/cerere-priority/cerere-priority.module';
import { StatusModule } from 'src/app/platform/nomenclatoare/cerere-status/status.module';
import { RequestTypesModule } from 'src/app/platform/nomenclatoare/cerere-type/cerere-type.module';
import { CerereSabloaneModule } from 'src/app/platform/nomenclatoare/cerere-sabloane/cerere-sabloane.module';
import { DocumentCategoryModule } from 'src/app/platform/nomenclatoare/document-category/document-category.module';
import { DocumentTypeModule } from 'src/app/platform/nomenclatoare/document-type/document-type.module';
import { DocumentTemplateModule } from 'src/app/platform/nomenclatoare/document-template/document-template.module';
import { TemplateCategoriesModule } from 'src/app/platform/nomenclatoare/template-categories/template-categories.module';
import { RegistreModule } from 'src/app/platform/nomenclatoare/registre/registre.module';
import { OperatoriModule } from 'src/app/platform/nomenclatoare/operatori/operatori.module';
import { ZileLibereModule } from 'src/app/platform/nomenclatoare/zile libere/zile-libere.module';
import { ActivityScheduleModule } from '../activity-schedule/activity-schedule.module';
import { MotiveRefuzModule } from 'src/app/platform/nomenclatoare/motive-refuz/motive-refuz.module';
import { GeneralModule } from 'src/app/platform/nomenclatoare/general/general.module';

@NgModule({
    declarations: [SettingsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        CererePriorityModule,
        StatusModule,
        RequestTypesModule,
        CerereSabloaneModule,
        DocumentCategoryModule,
        DocumentTypeModule,
        DocumentTemplateModule,
        TemplateCategoriesModule,
        RegistreModule,
        OperatoriModule,
        ZileLibereModule,
        ActivityScheduleModule,
        MotiveRefuzModule,
        GeneralModule,
    ],
    exports: [SettingsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule { }
